<template>
  <v-dialog v-model="data.dialogShow" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar color="gray" class="elevation-1">
        <v-btn
          color="light-blue darken-3"
          class="elevation-1"
          :loading="isLoading"
          @click="onSave()"
        >
          <v-icon class="pr-2">save</v-icon>SAVE
        </v-btn>
        <v-btn
          @click="data.dialogShow = false"
          color="red darken-1"
          class="elevation-1"
          :loading="isLoading"
        >
          <v-icon class="pr-2">close</v-icon>Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-items></v-toolbar-items>
      </v-toolbar>

      <v-card class="ma-3 pb-3" flat style="border:3px dashed darkgreen">
        <v-layout align-start justify-start row wrap>
          <v-flex md6>
            <v-alert
              class="ma-2"
              dismissible
              :value="alertValue"
              :color="alertColor"
              :icon="alertIcon"
              outline
            >{{alertMessage}}</v-alert>
          </v-flex>
        </v-layout>
        <v-layout align-start justify-start row wrap>
          <v-flex md4>
            <v-layout align-start justify-start row wrap>
              <v-flex md12 class="px-3">
                <v-text-field
                  label="Kode"
                  v-model="dataSubAspec.code"
                  v-validate="'required'"
                  data-vv-name="code"
                  :error-messages="errors.collect('code')"
                ></v-text-field>
              </v-flex>
              <v-flex md12 class="px-3">
                <v-text-field
                  label="Nama"
                  v-model="dataSubAspec.name"
                  v-validate="'required'"
                  data-vv-name="name"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
              </v-flex>
              <v-flex md12 class="px-3">
                <v-text-field label="Total Waktu" v-model="dataSubAspec.totalTime" mask="###"></v-text-field>
              </v-flex>
              <v-flex md12 class="px-3">
                <span class="body-2">Status :</span>
                <v-switch label="Enable" v-model="dataSubAspec.isEnabled"></v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6>
            <v-layout>
              <v-flex md3>                
                <v-select
                  hint="Tipe"
                  v-model="aspecTipeItemSelected"
                  :items="aspecTipeItems"
                  item-text="text"
                  item-value="value"
                  return-object
                  persistent-hint
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md12>               
                <v-textarea v-model="dataSubAspec.description" label="Keterangan"></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout align-start justify-start row wrap>
          <v-flex md12>
            <v-tabs left class="ml-3">
              <v-tab>INSTRUKSI</v-tab>
              <v-tab>LEMBAR PRA SOAL</v-tab>
              <v-tab>INSTRUKSI PENGERJAAN</v-tab>
              <v-tab-item>
                <quill-editor
                  :options="editorOption"
                  v-model="dataSubAspec.instruction"
                  class="pr-2 pt-3"
                ></quill-editor>
              </v-tab-item>
              <v-tab-item>
                <v-switch
                  label="Aktifkan Lembar Pra Soal"
                  v-model="dataSubAspec.is_enabled_lembar_pra_soal"
                ></v-switch>
                <v-text-field
                  :disabled="!dataSubAspec.is_enabled_lembar_pra_soal"
                  label="Total Waktu"
                  v-model="dataSubAspec.total_time_lembar_pra_soal"
                  mask="###"
                  style="width:100px;"
                ></v-text-field>
                <quill-editor
                  :disabled="!dataSubAspec.is_enabled_lembar_pra_soal"
                  :options="editorOption"
                  v-model="dataSubAspec.lembar_pra_soal"
                  class="pr-2 pt-3"
                ></quill-editor>
              </v-tab-item>
              <v-tab-item>
                <v-switch
                  label="Aktifkan Lembar Instruksi Pengerjaan"
                  v-model="dataSubAspec.is_enabled_instruksi_pengerjaan"
                ></v-switch>
                <quill-editor
                  :disabled="!dataSubAspec.is_enabled_instruksi_pengerjaan"
                  :options="editorOption"
                  v-model="dataSubAspec.instruksi_pengerjaan"
                  class="pr-2 pt-3"
                ></quill-editor>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>    
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import ApiService from "@/common/api.service";

export default {
  components: {
    quillEditor
  },
  props: {
    data: Object
  },
  data: () => ({
    isLoading: false,
    alertColor: "",
    alertIcon: "",
    alertValue: false,
    alertMessage: "",   
     aspecTipeItems: [
        { value: "NORMAL", text: "NORMAL" },
        { value: "NORMAL-COMBO", text: "NORMAL COMBO" },
        { value: "KM-KR", text: "KREATIVITAS" },
        { value: "KM-P1", text: "P1 / SE" },
        { value: "KM-P9", text: "P9 / ME" },
        { value: "HSPQ", text: "HSPQ" }
      ],
      aspecTipeItemSelected: { value: "NORMAL", text: "NORMAL" },

    dataSubAspec: {
      id: "",
      code: "",
      name: "",
      totalTime: 0,
      isEnabled: true,
      description: "",
      instruction: "",
      lembar_pra_soal: "",
      instruksi_pengerjaan: "",
      is_enabled_lembar_pra_soal: false,
      is_enabled_instruksi_pengerjaan: false,
      total_time_lembar_pra_soal: 0,
     
    },
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [
            {
              header: 1
            },
            {
              header: 2
            }
          ],
          [
            {
              list: "ordered"
            },
            {
              list: "bullet"
            }
          ],
          [
            {
              script: "sub"
            },
            {
              script: "super"
            }
          ],
          [
            {
              indent: "-1"
            },
            {
              indent: "+1"
            }
          ],
          [
            {
              direction: "rtl"
            }
          ],
          [
            {
              size: ["small", false, "large", "huge"]
            }
          ],
          [
            {
              header: [1, 2, 3, 4, 5, 6, false]
            }
          ],
          [
            {
              font: []
            }
          ],
          [
            {
              color: []
            },
            {
              background: []
            }
          ],
          [
            {
              align: []
            }
          ],
          ["clean"],
          ["link", "image", "video"]
        ],
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        }
      }
    },    
  }),
  
  methods: {
    getDataSubAspec: function() {
      const vm = this;
      vm.isLoading = true;
      ApiService.post("DataSubAspec/GetDataSubAspecById", {
        Id: vm.data.dataSubAspecId
      })
        .then(response => {             
          vm.dataSubAspec.id = response.data.id;
          vm.dataSubAspec.code = response.data.code;
          vm.dataSubAspec.name = response.data.name;
          vm.dataSubAspec.totalTime = response.data.totalTime;
          vm.dataSubAspec.isEnabled = response.data.isEnabled;
          vm.dataSubAspec.description = response.data.description;
          vm.dataSubAspec.instruction = response.data.instruction;
          vm.aspecTipeItemSelected.value = response.data.tipe;
          vm.dataSubAspec.lembar_pra_soal = 
          response.data.lembar_pra_soal === null
            ? ""
            : response.data.lembar_pra_soal;
          vm.dataSubAspec.instruksi_pengerjaan =
            response.data.instruksi_pengerjaan === null
              ? ""
              : response.data.instruksi_pengerjaan;
          vm.dataSubAspec.is_enabled_lembar_pra_soal =
            response.data.is_enabled_lembar_pra_soal === null
              ? false
              : response.data.is_enabled_lembar_pra_soal;
          vm.dataSubAspec.is_enabled_instruksi_pengerjaan =
            response.data.is_enabled_instruksi_pengerjaan === null
              ? false
              : response.data.is_enabled_instruksi_pengerjaan;
          vm.dataSubAspec.total_time_lembar_pra_soal =
            response.data.total_time_lembar_pra_soal === null
              ? 0
              : response.data.total_time_lembar_pra_soal;

          switch (response.data.tipe) {
            case "NORMAL":
              vm.aspecTipeItemSelected.text = "NORMAL";
              break;
            case "KM-P1":
              vm.aspecTipeItemSelected.text = "P1 / SE";
              break;
            case "KM-P9":
              vm.aspecTipeItemSelected.text = "P9 / ME";
              break;
            default:
              "";
          }          
          vm.isLoading = false;
        })
        .catch(() => {          
          vm.isLoading = false;
        });
    },
    onSave: function() {
      this.$validator.validate().then(valid => {
        if (valid) {
          const vm = this;
          vm.isLoading = true;
          ApiService.post("DataSubAspec/UpdateDataSubAspec", {
            Id: vm.dataSubAspec.id,
            Code: vm.dataSubAspec.code,
            Name: vm.dataSubAspec.name,
            Instruction: vm.dataSubAspec.instruction,
            TotalTime: vm.dataSubAspec.totalTime,
            Description: vm.dataSubAspec.description,
            IsEnabled: vm.dataSubAspec.isEnabled,
            sub_aspec_tipe: vm.aspecTipeItemSelected.value,
            lembar_pra_soal: vm.dataSubAspec.lembar_pra_soal,
            instruksi_pengerjaan: vm.dataSubAspec.instruksi_pengerjaan,
            is_enabled_lembar_pra_soal:
              vm.dataSubAspec.is_enabled_lembar_pra_soal,
            is_enabled_instruksi_pengerjaan:
              vm.dataSubAspec.is_enabled_instruksi_pengerjaan,
            total_time_lembar_pra_soal:
              vm.dataSubAspec.total_time_lembar_pra_soal
          })
            .then(() => {
              vm.isLoading = false;
              vm.$emit("close-window");
              // vm.clearForm();
              vm.data.dialogShow = false;
            })
            .catch(({ response }) => {
              vm.isLoading = false;
              if (response.status == 400) {
                vm.alertColor = "warning";
                vm.alertIcon = "priority_high";
                vm.alertValue = true;
                vm.alertMessage = response.data;
              } else {
                vm.alertColor = "error";
                vm.alertIcon = "warning";
                vm.alertValue = true;
                vm.alertMessage = response.data;
              }
            });
        }
      });
    }
  }
};
</script>
